import React from "react";
import { NextButton, PrevButton } from "./NextPrevButtons";


export const Card = ({result}) => {


    return ( 
               <>
                    <div className="cardGroup">
                    <div className="cardGroupWrapper">
                            <div className="imageWrapper"
                            >
                                <div className="pokeImage">
                                    <img className="pokeCardImage"
                                        src={result?result.cardItems.sprites.front_default:""}
                                    />
                                </div>                                               
                            </div>
                            <div className="contentWrapper">
                                <h2>{result.cardItems.name}</h2>
                                <span>
                                    type: {result.cardItems.types[0].type.name}
                                </span>
                            </div>                        
                        </div>
                    </div>
                </>
    )
}



export const CardButtonWrapper = ({paginate}) => {

    return (
            <div className="cardBtnWrapper">
                  <NextButton  paginate={paginate} />
                  <PrevButton  paginate={paginate} />
            </div>
    )

}